/**
 *
 * Email Integration
 *
 */

import React, { FC, useEffect } from 'react';

import { Clients } from '@ariksa/notification';
import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { WithResourceIcon } from 'components/DataDisplay';
import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { DeleteClientModal } from 'containers/Setup/Integrations/Components/Utils/DeleteClientModal';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { actions } from '../../../slice';

export const EmailTable: FC = () => {
  const dispatch = useDispatch();
  const { clients, client } = useSelector(selectIntegrations);
  const { clientActionsColumn, ...rest } = useIntegrations();

  useEffect(() => {
    dispatch(
      actions.loadClients({
        clientName: Clients.Email,
      }),
    );
  }, [dispatch]);

  const columns = [
    {
      header: <Box pl={16}>Connector Name</Box>,
      accessor: 'name',
      render: ({ value }) => (
        <WithResourceIcon resourceType={Clients.Email} spacing={10}>
          {value}
        </WithResourceIcon>
      ),
    },
    {
      header: 'Members',
      accessor: 'email',
      render: ({ value }) => value?.email_group?.length,
    },
    {
      header: 'Associations',
      accessor: 'associations',
    },
    {
      header: 'Created By',
      accessor: 'created_by',
    },
    clientActionsColumn,
  ];

  return (
    <>
      <Table
        columns={columns}
        data={clients.email}
        isLoading={clients.loading || client.isLoading}
      />
      {rest.isOpenDeleteClientModal && (
        <DeleteClientModal label="Delete Email Group" {...rest} />
      )}
    </>
  );
};
